window.$ = window.jQuery = require('jquery');
require('bootstrap');
require('alpinejs');
require('imask');
import {forEach, mergeWith, orderBy, toArray} from 'lodash';
import Vue from 'vue';
import {VueAutonumeric} from 'vue-autonumeric/src';
import {vueLaravelErrors} from './VueErrorMixin'
import {invalidacaoRespostasMixin} from './InvalidacaoRespostasMixin'
import {IMaskComponent} from 'vue-imask';

require('./livewire')

Vue.component( VueAutonumeric.name, VueAutonumeric );
Vue.mixin(vueLaravelErrors('object'))
Vue.mixin(invalidacaoRespostasMixin())
Vue.component(IMaskComponent.name, IMaskComponent)

window.Vue = Vue;
window.orderBy = orderBy;
window.forEach = forEach;
window.toArray = toArray;

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let inicializarAutoNumeric = (id = '', options = {}) => {
    let defaultOptions = {
        caretPositionOnFocus: "decimalRight",
        currencySymbol: "",
        decimalCharacter: ",",
        digitGroupSeparator: ".",
        decimalPlaces: 0,
        minimumValue: "0",
        unformatOnSubmit: false,
        modifyValueOnWheel: false,
    };
    return mergeWith(defaultOptions, options);
}

window.inicializarNumero = (id, options = {}) => {
    return inicializarAutoNumeric(id, options)
}

window.inicializarPorcentagem = (id, decimalPlaces = 0) => {
    return inicializarAutoNumeric(id, {
        decimalPlaces: decimalPlaces,
        minimumValue: "0.00",
        maximumValue: "999.00"
    })
}

window.escapeRegExp = function(termo) {
    var specialChars = [ '$', '^', '*', '(', ')', '+', '[', ']', '{', '}', '\\', '|', '.', '?', '/' ];
    var regex = new RegExp('(\\' + specialChars.join('|\\') + ')', 'g');
    return termo.replace(regex, '\\$1');
}

/**
 * Cria os tooltips de termos
 * @param termos: Array
 * @param container: string|null
 */
window.inicializarTermos = function (termos, container) {
    $("[data-termos=true]", container ? container : "body")
        .each(function () {
            for (let i = 0; i < termos.length; i++) {
                let termo = termos[i];
                let regex = new RegExp(escapeRegExp(termo.expressao), "gmi");
                let element = $(this).get(0);
                let extraClass = !termo.exibe_nos_campos ? 'sem-sublinhado' : '';
                let significado = termo.exibe_nos_campos ? termo.significado : '';

                for (let j = 0; j < element.childNodes.length; j++) {
                    let node = element.childNodes[j];
                    if (node.nodeType !== Node.TEXT_NODE || !regex.test(node.nodeValue)) {
                        continue;
                    }
                    let str_replace = `<abbr data-content="${significado}" class="termo ${extraClass}">$&</abbr>`;
                    if (termo.exibe_no_glossario) {
                        str_replace = `
                            ${str_replace}
                            <a href="${termo.url}" target="_blank" rel="noopener noreferrer" title="Acessar o glossário" class="icone-glossario">
                                <i class="fas fa-fw fa-question-circle small" aria-hidden="true"></i>
                                <span class="sr-only">Glossário</span>
                            </a>
                        `;
                    }
                    let html = node.nodeValue.replace(
                        regex,
                        str_replace
                    );
                    $(node).replaceWith(html)
                    j = -1;
                }
            }
        });

    $('.popover').remove();

    $(".termo", container ? container : "body")
        .popover({
            container: "body",
            html: true,
            trigger: "manual",
        })
        .on("mouseover", function () {
            $(this).popover("show");
        })
        .on("mouseleave", function () {
            setTimeout(() => {
                let _this = this;
                if (!$(".popover:hover").length) {
                    $(this).popover("hide");
                } else {
                    $('.popover').mouseleave(function () {
                        $(_this).popover("hide");
                        $(this).off('mouseleave');
                    });
                }
            }, 1000)
        });

    $(".icone-glossario", container ? container : "body")
        .tooltip({
            container: "body"
        });
}

$('document').ready(() => {
    $('#sidepanelToogle').on('click', (event) => {
        let sidepanel = $('#sidepanel');
        let $form = $('.form-gife');

        sidepanel.toggleClass('collapsed');
        $form.toggleClass('sidepanel-collapsed');
    })
    $('[data-toggle="tooltip"], [data-ttoggle="tooltip"]').tooltip({ trigger: "hover" })
})

window.inicializarEditor = (seletor, campoId) => {
    $(seletor).each(function() {
        $(this).summernote('destroy');
    });
    $(seletor).summernote({
        height: 320,
        tabsize: 2,
        lang: 'pt-BR',
        toolbar: [
            ['font', ['bold', 'italic', 'underline']],
            ['para', ['ul', 'ol']],
            ['insert', ['link']],
        ],
        callbacks: {
            onChange: function (contents, $editable) {
                document.getElementById(campoId)
                    .dispatchEvent(
                        new Event(
                            'input', {
                                bubbles: true,
                                cancelable: false,
                            }
                        )
                    );
            },
            onPaste: function (e) {
                let content = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('text/html');
                e.preventDefault();

                // 1. remove line breaks / Mso classes
                let stringStripper = /(\n|\r| class=(")?Mso[a-zA-Z]+(")?)/g;
                let output = content.replace(stringStripper, ' ');
                // 2. strip Word generated HTML comments
                let commentSripper = new RegExp('<!--(.*?)-->','g');
                output = output.replace(commentSripper, '');
                let tagStripper = new RegExp('<(/)*(svg|video|img|meta|link|\\?xml:|st1:|o:|font)(.*?)>','gi');
                // 3. remove tags leave content if any
                output = output.replace(tagStripper, '');
                // 4. Remove everything in between and including tags '<style(.)style(.)>'
                let badTags = ['style', 'script','applet','embed','noframes','noscript', 'iframe', 'form'];

                for (let i=0; i< badTags.length; i++) {
                    tagStripper = new RegExp('<'+badTags[i]+'.*?'+badTags[i]+'(.*?)>', 'gi');
                    output = output.replace(tagStripper, '');
                }
                // 5. remove attributes ' style="..."'
                let badAttributes = ['style', 'start'];
                for (let i=0; i< badAttributes.length; i++) {
                    let attributeStripper = new RegExp(' ' + badAttributes[i] + '="(.*?)"','gi');
                    output = output.replace(attributeStripper, '');
                }

                document.execCommand('insertHtml', false, output);
            }
        }
    });
}
